var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{attrs:{"height":_vm.height,"src":_vm.getHeroPath(_vm.hero),"alt":_vm.hero}})
}
var staticRenderFns = []

export { render, staticRenderFns }